// ===================================================================
// STATUS IGRACA U KOLU — cist sloj, bez Reacta
//
// Zasto zaseban fajl (28.08.2026): ista logika je bila prepisana na DVA mesta
// u App.jsx (prvo ucitavanje i osvezavanje na 60s) i vec se razisla — jedno
// mesto je citalo sirov fixture (`finished` / `started`), drugo obradjen
// (`status`). Ovde je jednom, i testira se.
//
// BAG KOJI JE OVO OTKRIO (Filip, 28.08, GW2 uzivo):
// brojac "Jos igra" i tackica pored imena koristili su ISTI uslov `!isFinished`.
// Taj uslov spaja dva razlicita stanja: "mec jos nije poceo" i "igra bas sada".
// Posledica: dok je Sitijev mec trajao, Haland i Foden su se racunali u
// "jos igra", brojac je stajao na 11, a tackica se pojavljivala i na igracima
// cija utakmica nije ni pocela.
//
// Tri stanja se od sada drze odvojeno:
//   upcoming  mec jos nije poceo   -> ulazi u brojac "Jos igra"
//   inPlay    igra bas sada        -> dobija tackicu
//   finished  mec gotov            -> ni jedno ni drugo
//   (blank)   nema meca u kolu     -> ni jedno ni drugo
// ===================================================================

// Status jednog meca, iz OBA oblika koja App.jsx koristi:
// sirov fixture sa FPL-a (`finished`, `finished_provisional`, `started`)
// i obradjen fixture (`status`). Redosled provera je bitan: gotov mec ima
// i `started: true`, pa se gotovost proverava prva.
export function statusMeca(f) {
  if (!f) return null;
  if (f.status === "finished" || f.finished || f.finished_provisional) return "finished";
  if (f.status === "inPlay" || f.started) return "inPlay";
  return "upcoming";
}

// Status igraca iz SVIH mECEVA njegovog kluba u tom kolu.
// Niz, ne jedan mec: u duplom kolu klub igra dvaput, pa bi `find` uzeo prvi i
// oznacio igraca kao gotovog dok mu drugi mec jos predstoji.
// Prazan niz = prazno kolo za taj klub (blank) -> null, nema sta da se ceka.
export function statusIgraca(mecevi) {
  const lista = (mecevi || []).map(statusMeca).filter(Boolean);
  if (lista.length === 0) return null;
  if (lista.includes("inPlay")) return "inPlay";
  if (lista.includes("upcoming")) return "upcoming";
  return "finished";
}

// Tri zastavice koje liveData nosi po igracu. Blank kolo daje sve tri false —
// takav igrac nije ni "jos igra" ni "igra sada", jer nema sta da odigra.
export function zastaviceStatusa(status) {
  return {
    inPlay: status === "inPlay",
    isFinished: status === "finished",
    isUpcoming: status === "upcoming",
  };
}

// Svi mecevi jednog kluba u kolu.
export function meceviKluba(gwFixtures, teamId) {
  if (teamId == null) return [];
  return (gwFixtures || []).filter((f) => f && (f.team_h === teamId || f.team_a === teamId));
}
